import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectInput } from "../form-inputs";
import { FlatErrorValidationResult } from "../../utils/validation/flatErrorMap";

export interface LocationItem {
    locationId: number | null;
    areaName: string;
    locationName: string;
}

export interface LocationSelectorProps {
    selectedId: number | null;
    locationList: LocationItem[];
    label?: string;
    mandatory?: boolean;
    errorMessage?: string;
    noEmptyLocationItem?: boolean;
    onValueChange?(item: LocationItem): void;
    disabled?: boolean;
    emptyValueLabel?: string;
}

function LocationSelector(props: LocationSelectorProps) {
    const { t } = useTranslation("common");

    const [locationDropdownData, setLocationDropdownData] = useState([]);

    const {
        locationList,
        label,
        selectedId,
        onValueChange,
        mandatory,
        errorMessage,
        noEmptyLocationItem,
        disabled,
        emptyValueLabel,
    } = props;

    const EMPTY_LOCATION_ITEM = {
        id: null,
        areaName: "",
        locationId: null,
        locationName: "",
        value: emptyValueLabel ? emptyValueLabel : t("NoRoomAssigned"),
    };

    useEffect(() => {
        setLocationDropdownData(buildLocationDropdownData());
    }, [locationList]);

    const getDefaultItem = () => {
        if (noEmptyLocationItem) {
            if (locationDropdownData.length != 0 && locationDropdownData[0]) {
                if (onValueChange) onValueChange(locationDropdownData[0]);
                return locationDropdownData[0];
            }
        }
        if (onValueChange) onValueChange(EMPTY_LOCATION_ITEM);
        return EMPTY_LOCATION_ITEM;
    };

    const buildLocationDropdownData = () => {
        const dropdownData: any = locationList
            .map((value: LocationItem) => ({
                id: value.locationId,
                areaName: value.areaName,
                locationId: value.locationId,
                locationName: value.locationName,
                value: `${value.areaName} - ${value.locationName}`,
            }))
            .sort((a: any, b: any) => {
                return a.value.localeCompare(b.value, undefined, {
                    numeric: true,
                });
            });

        if (!noEmptyLocationItem) dropdownData.unshift(EMPTY_LOCATION_ITEM);

        return dropdownData;
    };

    const selectedRoom =
        buildLocationDropdownData().find((value: any) => {
            return Number(value.id) === Number(selectedId);
        }) || getDefaultItem();

    return (
        <SelectInput
            showToolTip
            mandatory={mandatory}
            options={buildLocationDropdownData()}
            label={label}
            placeholder={
                emptyValueLabel ? emptyValueLabel : t("NoRoomAssigned")
            }
            value={{ ...selectedRoom }}
            onChange={(_event: any, value: LocationItem) => {
                if (onValueChange) {
                    onValueChange(value);
                }
            }}
            errorMessage={errorMessage}
            disabled={disabled}
        ></SelectInput>
    );
}

export default LocationSelector;
